import type { ProductIdentifier } from "../../../../aysa_api/entities/products/v1/product_identifier.types";
import { Reader, Writer } from "protobufjs/minimal";
import type { Long } from "protoc-gen-ts";

export const createBaseProductIdentifier = (): ProductIdentifier => {
  return {};
};

export const decodeProductIdentifier = (
  reader: Reader,
  length: number
): ProductIdentifier => {
  const end = reader.pos + length;
  const message = createBaseProductIdentifier();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.identifier = {
          $case: "id",
          id: (reader.int64() as Long).toNumber(),
        };

        break;
      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeProductIdentifier = (
  writer: Writer,
  message: ProductIdentifier
): Writer => {
  if (message.identifier !== undefined) {
    switch (message.identifier.$case) {
      case "id":
        writer.uint32(8).int64(message.identifier.id);

        break;
    }
  }
  return writer;
};
